import { render, staticRenderFns } from "./Block3.vue?vue&type=template&id=4bdd87b6"
import script from "./Block3.vue?vue&type=script&lang=js"
export * from "./Block3.vue?vue&type=script&lang=js"
import style0 from "./Block3.vue?vue&type=style&index=0&id=4bdd87b6&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bdd87b6')) {
      api.createRecord('4bdd87b6', component.options)
    } else {
      api.reload('4bdd87b6', component.options)
    }
    module.hot.accept("./Block3.vue?vue&type=template&id=4bdd87b6", function () {
      api.rerender('4bdd87b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/Block3.vue"
export default component.exports